module.exports = __webpack_public_path__ + "assets/img/road-m.01b8a83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/road-m.jpg
// module id = tIRK
// module chunks = 0